import { useState } from "react";

export const useBookingDateState = (
  initialStart: number | Date,
  initialEnd: number | Date
) => {
  const initializeDate = (value?: number | Date) =>
    value ? new Date(value) : null;

  const [reservationStartDate, setStartDate] = useState<Date | null>(
    initializeDate(initialStart)
  );
  const [reservationEndDate, setEndDate] = useState<Date | null>(
    initializeDate(initialEnd)
  );

  return { reservationStartDate, setStartDate, reservationEndDate, setEndDate };
};
